import { Fee } from '@/interfaces/fee';
import { EntityResource } from './entity.resource';
import { FeeFilterVariables } from './queryVariables/filters/fee.filters';

/**
 * Resource składek
 *
 * @export
 * @class SportResource
 * @extends {EntityResource<Sport>}
 */
export class FeeResource extends EntityResource<Fee> {
  protected getFields = {
    id: true,
    name: true,
    price: true
  };

  protected listFields = {
    id: true,
    name: true
  };

  protected listVariables = FeeFilterVariables;

  constructor() {
    super({ entityName: 'fee' });
  }
}

export const feeResource = new FeeResource();
